/**
 * One layout for every speaker, mirrored for the user: a 28px round avatar
 * beside the name, and the message indented so its text starts under the
 * name. Speakers are separated by space, not rules.
 */
export const AVATAR_SIZE = 28;
export const AVATAR_GAP = 10;
/** Where message text starts, measured from the speaker's own edge. */
export const MESSAGE_INDENT = AVATAR_SIZE + AVATAR_GAP;
export const SPEAKER_GAP = 20;
/** The accent rule beside a persistent agent's reply, and the space after it. */
export const SPEAKER_RULE_WIDTH = 2;
export const SPEAKER_RULE_PADDING = 12;
export const USER_BUBBLE_RADIUS = 14;

/** A message inside a tinted surface: no background or outer margins of its own. */
export const flushMarkdown = {
  "& .chat-markdown": { backgroundColor: "transparent" },
  "& .chat-markdown > :first-of-type, & .chat-markdown p:first-of-type": { mt: 0 },
  "& .chat-markdown > :last-child, & .chat-markdown p:last-of-type": { mb: 0 },
} as const;

/**
 * Widest the conversation column gets; wider panels centre it.
 *
 * Material 3 has no chat-specific width, so this is a judgment from its
 * guidance: 840dp is where M3's "expanded" window class starts, i.e. the
 * widest single-pane content it designs for, and prose past that runs well
 * beyond a comfortable reading line. Tables and charts still get the full
 * column. The input bar shares the cap so the two line up.
 */
export const CHAT_MAX_WIDTH = 840;
